import { createSlice } from "@reduxjs/toolkit";
import {
    formInitAssetsSimulation,
    formInitEquivalency,
    formInitProviderSimulation,
    loadingsSimulation,
    modalsSimulation,
} from "../../../types/initStore/initSimulation";
import { typeForm } from "../../../types/forms";

const initialState = {
    loadings: loadingsSimulation,
    formEquivalecy: formInitEquivalency,
    projectId: 0,
    isExistHrsEquivalency: true,
    errorSimulation: false,
    tableEquivalencySimulation: [],
    modals: modalsSimulation,
    areasTeam: [],
    //* assets
    assetsTable: [],
    formAssets: formInitAssetsSimulation,
    tableEquivalencyAssets: [],
    //* providers
    providersTable: [],
    formProviders: formInitProviderSimulation,
    tableEquivalencyProviders: [],
    //* providers calculation
    providersCalculationTable: [],
    //* info
    tableInfo: [],
    tableInfoHrs: [],
    projectData: {},
    //* type
    selectTypeForm: typeForm.create,
    selectId: "",
};

export const isSimulationSlice = createSlice({
    name: "simulation",
    // estado inicial definido en la parte superior line:3
    initialState,
    // todas las acciones que puden modificar el store
    reducers: {
        setLoadingSimulation: (state, { payload }) => {
            state.loadings = payload;
        },
        setModals: (state, { payload }) => {
            state.modals = payload;
        },
        setIsExistHrsEquivalency: (state, { payload }) => {
            state.isExistHrsEquivalency = payload;
        },
        setTableEquivalencySimulation: (state, { payload }) => {
            state.tableEquivalencySimulation = payload;
        },
        setTableEquivalencyAssets: (state, { payload }) => {
            state.tableEquivalencyAssets = payload;
        },
        setTableEquivalencyProvider: (state, { payload }) => {
            state.tableEquivalencyProviders = payload;
        },
        setErrorSimulation: (state, { payload }) => {
            state.errorSimulation = payload;
        },
        setFormEquivalecy: (state, { payload }) => {
            state.formEquivalecy = payload;
        },
        setProjectId: (state, { payload }) => {
            state.projectId = payload;
        },
        setAreasTeam: (state, { payload }) => {
            state.areasTeam = payload;
        },
        setAssetsTable: (state, { payload }) => {
            state.assetsTable = payload;
        },
        setFormAssets: (state, { payload }) => {
            state.formAssets = payload;
        },
        setSelectTypeForm: (state, { payload }) => {
            state.selectTypeForm = payload;
        },
        setSelectId: (state, { payload }) => {
            state.selectId = payload;
        },
        setProvidersTable: (state, { payload }) => {
            state.providersTable = payload;
        },
        setFormProviders: (state, { payload }) => {
            state.formProviders = payload;
        },
        setTableInfoGeneral: (state, { payload }) => {
            state.tableInfo = payload.tableInfo;
            state.tableInfoHrs = payload.tableInfoHrs;
        },
        setProjectData: (state, { payload }) => {
            state.projectData = payload;
        },
        setProvidersCalculationTable: (state, { payload }) => {
            state.providersCalculationTable = payload;
        },
    },
});

export const {
    setLoadingSimulation,
    setModals,
    setIsExistHrsEquivalency,
    setProjectId,
    setTableEquivalencySimulation,
    setErrorSimulation,
    setFormEquivalecy,
    setAreasTeam,
    setAssetsTable,
    setFormAssets,
    setSelectTypeForm,
    setSelectId,
    setProvidersTable,
    setFormProviders,
    setTableInfoGeneral,
    setProjectData,
    setTableEquivalencyAssets,
    setTableEquivalencyProvider,
    setProvidersCalculationTable,
} = isSimulationSlice.actions;
